import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
// import * as serviceWorker from "./serviceWorker";
// import * as firebase from 'firebase/app';
// import { initializeApp } from 'firebase/app';
// import { getFirestore } from "firebase/firestore";

// import { initializeApp } from 'firebase/app';
// import { getFirestore, collection, getDocs } from 'firebase/firestore';
import * as firebase from "firebase/app";
import "firebase/firestore";
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC_Ue3ttMNFNrXQQSWZei1ElNtGgHgAFK8",
  authDomain: "cart-9eb61.firebaseapp.com",
  projectId: "cart-9eb61",
  storageBucket: "cart-9eb61.appspot.com",
  messagingSenderId: "891503210024",
  appId: "1:891503210024:web:fed6fb71e2029a6c240f1d",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
